// import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const useScrollToTop = () => {
  // const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      window.scrollTo(0, 0);
    };
  }, [window.location.pathname]);

  return null;
};

export default useScrollToTop;
